import { Box, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

import { getStyles } from './SplitPaper.styles';

interface SplitPaperProps {
  layout: 'textLeftImageHalf' | 'textLeftImageFull' | 'textRightImageHalf' | 'textRightImageFull';
  media: React.ReactElement<HTMLImageElement>;
  button?: React.ReactElement;
  text: React.ReactElement;
}

export type Size = 'half' | 'full';
export type Direction = 'left' | 'right';

const parseLayout = (layout: string) => {
  const size = layout.split('Image');
  const direction = size[0].split('text')[1].toLowerCase();
  return { size: size[1].toLowerCase() as Size, direction: direction as Direction };
};

export const SplitPaper: React.FC<SplitPaperProps> = ({ layout, media, text, button }) => {
  const theme = useTheme();
  const { size, direction } = useMemo(() => parseLayout(layout), [layout]);
  const styles = getStyles({ size, direction }, theme);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.media}>
        {media
          ? React.cloneElement(media, {
              style: {
                ...media.props.style,
                gridColumnStart: direction === 'right' && size === 'half' ? '2' : '1',
                gridColumnEnd: size === 'full' ? '3' : '2',
                aspectRatio: size === 'full' ? '16 / 9' : '1 / 1',
              },
            })
          : null}
      </Box>
      <Box sx={styles.content}>
        <Box sx={styles.text}>{text}</Box>
        {button && <Box sx={styles.button}>{button}</Box>}
      </Box>
    </Box>
  );
};
